import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_info",
  "use": "svg_info-usage",
  "viewBox": "0 0 16 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 15\" id=\"svg_info\"><path d=\"M8 .062a7.312 7.312 0 1 0 7.313 7.313A7.32 7.32 0 0 0 8 .062Zm0 13.5a6.187 6.187 0 1 1 6.188-6.187A6.195 6.195 0 0 1 8 13.562Zm1.125-2.813a.563.563 0 0 1-.563.563 1.125 1.125 0 0 1-1.124-1.125V7.375a.563.563 0 1 1 0-1.125 1.125 1.125 0 0 1 1.125 1.125v2.812a.562.562 0 0 1 .562.563Zm-2.25-6.468a.844.844 0 1 1 1.687 0 .844.844 0 0 1-1.687 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol